<div [formGroup]="form">
  <div class="raptor-validation-layout">

    <ng-container [ngSwitch]="question.layout">
      <ng-container *ngSwitchCase="'bupa_mem_num'" [formGroupName]="question.key">
        <mat-form-field appearance="outline" class="raptor-validation-input" [class]="'max-length-' + question.settings.attributes?.maxlength">
          <input
            matInput
            type="text"
            id="number"
            formControlName="number"
            [maxlength]="question.settings.attributes?.maxlength"
            [placeholder]="question.settings.placeholder"
            [readonly]="memberValidationResponse?.is_valid === true || isMemberValidationExhausted === true"
          />
          <open-svg-icon
            matSuffix
            class="validate-on-change-icon"
            [name]="question.settings.validateOnChange.valid"
            *ngIf="memberValidationResponse?.is_valid === true && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'"
          ></open-svg-icon>
          <open-svg-icon
            matSuffix
            class="validate-on-change-icon xsmall"
            [name]="question.settings.validateOnChange.error"
            *ngIf="memberValidationResponse?.is_valid === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'"
          ></open-svg-icon>
        </mat-form-field>
        <input type="hidden" id="type" formControlName="type"/>
        <mat-form-field appearance="outline" class="raptor-validation-input" class="max-length-2">
          <input
            matInput
            type="text"
            id="suffix"
            formControlName="suffix"
            minlength="1"
            maxlength="2"
            placeholder="e.g.123"
            [readonly]="memberValidationResponse?.is_valid === true || isMemberValidationExhausted === true"
          />
          <open-svg-icon
            matSuffix
            class="validate-on-change-icon"
            [name]="question.settings.validateOnChange.valid"
            *ngIf="memberValidationResponse?.is_valid === true && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'"
          ></open-svg-icon>
          <open-svg-icon
            matSuffix
            class="validate-on-change-icon xsmall"
            [name]="question.settings.validateOnChange.error"
            *ngIf="memberValidationResponse?.is_valid === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'"
          ></open-svg-icon>
        </mat-form-field>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <mat-form-field appearance="outline" class="raptor-validation-input" [class]="'max-length-' + question.settings.attributes?.maxlength">
          <input
            matInput
            type="text"
            [id]="question.key"
            [formControlName]="question.key"
            [maxlength]="question.settings.attributes?.maxlength"
            [placeholder]="question.settings.placeholder"
            [readonly]="memberValidationResponse?.is_valid === true || isMemberValidationExhausted === true"
          />
          <open-svg-icon
            matSuffix
            class="validate-on-change-icon"
            [name]="question.settings.validateOnChange.valid"
            *ngIf="memberValidationResponse?.is_valid === true && question.settings.validateOnChange.valid && question.settings.validateOnChange.position === 'after'"
          ></open-svg-icon>
          <open-svg-icon
            matSuffix
            class="validate-on-change-icon xsmall"
            [name]="question.settings.validateOnChange.error"
            *ngIf="memberValidationResponse?.is_valid === false && question.settings.validateOnChange.error && question.settings.validateOnChange.position === 'after'"
          ></open-svg-icon>
        </mat-form-field>
      </ng-container>

      <button
        mat-stroked-button
        color="secondary"
        type="button"
        class="raptor-validation-submit small"
        [disabled]="disableValidateButton()"
        (click)="validateBupaNumber()"
      >
        Validate
      </button>
    </ng-container>

  </div>
</div>

<div *ngIf="memberValidationResponse?.is_valid === false" class="open-form-info radius-ai padding-medium margin-top-medium is-error">
  <div>
    <h4 class="is-error">{{ errorHeading }}</h4>
    <p>{{ memberValidationResponse?.message }}</p>
  </div>
</div>

<div *ngIf="memberValidationResponse?.is_valid === true" class="open-form-info radius-ai padding-medium margin-top-medium">
  <div>
    <h4>{{ question.settings.message_valid }}</h4>
  </div>
</div>